import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // static targets = [
  //   'doubleRoom',
  //   'featureContent',
  //   'normalRoom',
  //   'privateRoom',
  //   'recreation',
  //   'twentyFourHourNursing',
  // ]

  // connect () {
  //   this.changeTagColor()
  // }

  // get className () {
  //   return this.element.dataset.classname
  // }

  // changeTagColor () {
  //   if (!this.featureContentTarget.dataset.featureContentIds) return

  //   const featureContentIds = JSON.parse(this.featureContentTarget.dataset.featureContentIds)
  //   this.changeNursingTagColor(featureContentIds)
  //   this.changeRoomTypeTagColor(featureContentIds)
  //   this.changeRecreationTagColor(featureContentIds)
  // }

  // changeNursingTagColor (featureContentIds) {
  //   const twentyFourHourNursingId = '103'

  //   if (featureContentIds.includes(twentyFourHourNursingId)) {
  //     this.twentyFourHourNursingTarget.classList.remove(`${this.className}::content-item-tag`)
  //     this.twentyFourHourNursingTarget.classList.add(`${this.className}::content-item-tag-active`)
  //   }
  // }

  // changeRoomTypeTagColor (featureContentIds) {
  //   const privateRoomId = '201'
  //   const doubleRoomId = '202'

  //   if (featureContentIds.includes(privateRoomId)) {
  //     this.normalRoomTarget.classList.remove(`${this.className}::content-item-tag-active`)
  //     this.normalRoomTarget.classList.add(`${this.className}::content-item-tag`)
  //     this.privateRoomTarget.classList.remove(`${this.className}::content-item-tag`)
  //     this.privateRoomTarget.classList.add(`${this.className}::content-item-tag-active`)
  //   } else if (featureContentIds.includes(doubleRoomId)) {
  //     this.normalRoomTarget.classList.remove(`${this.className}::content-item-tag-active`)
  //     this.normalRoomTarget.classList.add(`${this.className}::content-item-tag`)
  //     this.doubleRoomTarget.classList.remove(`${this.className}::content-item-tag`)
  //     this.doubleRoomTarget.classList.add(`${this.className}::content-item-tag-active`)
  //   }
  // }

  // changeRecreationTagColor (featureContentIds) {
  //   const recreationId = '401'

  //   if (featureContentIds.includes(recreationId)) {
  //     this.recreationTarget.classList.remove(`${this.className}::content-item-tag`)
  //     this.recreationTarget.classList.add(`${this.className}::content-item-tag-active`)
  //   }
  // }
}
